import React from 'react';
import {
  AspectRatio,
  DriveFolderUpload,
  Edit,
  LocalShipping,
  People,
  RateReview,
  VerifiedUser,
} from '@mui/icons-material';
import { LocaleRoutes } from 'locale/locale';
import { Role } from 'store/user/auth0.helpers';
import { FeatureFlag } from 'utils/helpers/featureFlag.helpers';
import { adminRoles, approverRoles, entryRoles, reviewerRoles, satoRoles } from 'utils/helpers/permissions.helpers';

export interface NavigationLink {
  name: keyof LocaleRoutes;
  route: string;
  icon: React.ReactNode;
  roles?: Role[];
  featureFlag?: FeatureFlag;
}

export const IS_DEMO_APP = process.env.REACT_APP_ENV === 'DEMO';

export const navigationLinks: NavigationLink[] = [
  { name: 'drafts', route: '/drafts', roles: entryRoles, icon: <Edit sx={{ mr: '1rem' }} /> },
  {
    name: 'review',
    route: '/review',
    icon: <RateReview sx={{ mr: '1rem' }} />,
    roles: reviewerRoles,
  },
  {
    name: 'approve',
    route: '/approve',
    icon: <VerifiedUser sx={{ mr: '1rem' }} />,
    roles: approverRoles,
  },
  {
    name: 'sato',
    route: '/sato',
    icon: <AspectRatio sx={{ mr: '1rem' }} />,
    roles: satoRoles,
  },
  {
    name: 'userManagement',
    route: '/user-management',
    icon: <People sx={{ mr: '1rem' }} />,
    roles: adminRoles,
  },
  {
    name: 'deliveryPortal',
    route: '/delivery-portal',
    icon: <LocalShipping sx={{ mr: '1rem' }} />,
    roles: adminRoles,
    featureFlag: 'DELIVERY_PORTAL',
  },
  {
    name: 'dataUpload',
    route: '/data-upload/list',
    icon: <DriveFolderUpload sx={{ mr: '1rem' }} />,
    roles: adminRoles,
  },
];
